// extracted by mini-css-extract-plugin
module.exports = {"timer":"_13787","item":"_14831","divider":"_8888","unit":"_18882"};